<div class="financiamento">
  <div class="container">
    <form [formGroup]="form" novalidate (keydown.enter)="$event.preventDefault()">
      <div class="dados-recebidos">
        <h5 class="title">Dados do Financiamento</h5>
        <table class="table">
          <thead>
            <tr>
              <th>Identificador</th>
              <th>Pedido</th>
              <th>Valor</th>
              <th>Valor Taxas(soma na 1º parcela)</th>
              <th>Valor Taxas(diluído nas parcelas)</th>
              <th>Qtde Parcelas</th>
              <th>Primeiro Vencimento</th>
              <th>Situação</th>
              <th>Ver Boleto</th>
            </tr>
          </thead>
          <tbody>
            <td class="linhas-tabela">{{registro.CodigoInterno}}</td>
            <td class="linhas-tabela">{{registro.CodigoPedido}}</td>
            <td class="linhas-tabela">{{registro.ValorTotal | currency:'BRL':true:'1.2-2' }}</td>
            <td class="linhas-tabela">{{registro.ValorEntrada | currency:'BRL':true:'1.2-2' }}</td>
            <td class="linhas-tabela">{{registro.Taxas | currency:'BRL':true:'1.2-2' }}</td>
            <td class="linhas-tabela">{{registro.Parcelas}}</td>
            <td class="linhas-tabela">{{registro.DataPrimeiroVencimento | date: "dd/MM/yyyy"}}</td>
            <td [ngSwitch]="registro.Status">
              <span *ngSwitchCase="0" id="statusFinanciamento"
                class="badge badge-pill badge-black">{{registro.StatusDesc}}</span>
              <span *ngSwitchCase="1" id="statusFinanciamento"
                class="badge badge-pill badge-danger">{{registro.StatusDesc}}</span>
              <span *ngSwitchCase="2" id="statusFinanciamento"
                class="badge badge-pill badge-danger">{{registro.StatusDesc}}</span>
              <span *ngSwitchCase="3" id="statusFinanciamento"
                class="badge badge-pill badge-danger">{{registro.StatusDesc}}</span>
              <span *ngSwitchCase="4" id="statusFinanciamento"
                class="badge badge-pill badge-success">{{registro.StatusDesc}}</span>
              <span *ngSwitchCase="5"
                class="badge badge-pill badge-danger">{{registro.Status}}{{registro.StatusDesc}}</span>
            </td>
            <td *ngIf="registro.Status == 2">
              <button (click)="abrirModal(contentBoleto, registro.CodigoInterno)" type="button"
                class="btn btn-xs botao-editar" style="margin-left: 5px;" title="Visualizar">
                <span class="fa fa-eye"></span>
              </button>
            </td>
          </tbody>
        </table>
      </div>
      <div class="dados-pessoais">
        <h5 class="title">Dados Pessoais</h5>
        <div class="form">
          <div class="row">
            <div class="col-4 ">
              <label for="floatingInput">Nome</label>
              <input type="text" autocomplete="off" [(ngModel)]="registro.Nome" formControlName="Nome"
                name="inputTitulo">
              <span *ngIf=""></span>
            </div>
            <div class="col-4">
              <label for="floatingInput">Sobrenome</label>
              <input type="text" [(ngModel)]="registro.Sobrenome" formControlName="Sobrenome" name="inputTitulo">
            </div>
            <div class="col-4">
              <label for="floatingInput">CPF</label>
              <input type="text" mask="000.000.000-00" [dropSpecialCharacters]="false" [(ngModel)]="registro.CPF" formControlName="CPF"
                name="inputTitulo">
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <label for="floatingInput">RG</label>
              <input type="text" [(ngModel)]="registro.RG" formControlName="RG" name="inputRG">
            </div>
            <div class="col-4">
              <label for="floatingInput">Orgão Emissor</label>
              <input type="text" [(ngModel)]="registro.OrgaoEmissor" formControlName="OrgaoEmissor"
                name="inputOrgaoEmissor">
            </div>
            <div class="col-4">
              <label for="floatingInput">Data de Nascimento</label>
              <input autocomplete="off" type="text" mask="99/99/9999" [(ngModel)]="dataNascimento" formControlName="DataNascimento"
                name="inputDataNascimento" (ngModelChange)="setDataNascimento($event)">
              <span *ngIf="registro.DataNascimento && !validaData(dataNascimento)" style="color: red">Data
                inválida</span>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <label for="floatingInput">Email</label>
              <input autocomplete="off" type="text" class="form-control" [(ngModel)]="registro.Email"
                formControlName="Email" name="inputEmail">
            </div>
            <div class="col-4">
              <label for="floatingInput">Telefone Celular</label>
              <input type="text" mask="99 999999999||99 99999999" [(ngModel)]="registro.Celular" formControlName="Celular"
                name="inputCelular">
            </div>
            <div class="col-4">
              <label for="floatingInput">Telefone Residencial</label>
              <input type="text" mask="99 999999999||99 99999999" [(ngModel)]="registro.TelefoneResidencial"
                formControlName="TelefoneResidencial" name="inputTelefoneREsidencial">
            </div>
          </div>
        </div>
      </div>
      <div class="dados-residenciais">
        <h5 class="title">Dados Residenciais</h5>
        <div class="form">
          <div class="row">
            <div class="col-4 ">
              <label for="floatingInput">CEP</label>
              <input type="text" mask="99999 999" [(ngModel)]="registro.Cep" formControlName="Cep" name="inputCep"
                (blur)="buscaCepPax()">
            </div>
            <div class="col-4">
              <label for="floatingInput">Logradouro</label>
              <input type="text" [(ngModel)]="registro.Logradouro" formControlName="Logradouro" name="inputLogradouro">
            </div>
            <div class="col-4">
              <label for="floatingInput">Número</label>
              <input type="text" [(ngModel)]="registro.Numero" formControlName="Numero" name="inputNumero">
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <label for="floatingInput">Bairro</label>
              <input type="text" [(ngModel)]="registro.Bairro" formControlName="Bairro" name="inputBairro">
            </div>
            <div class="col-2">
              <label for="floatingInput">Cidade</label>
              <input type="text" [(ngModel)]="registro.CidadeDs" formControlName="CidadeDs" name="inputCidade">
            </div>
            <div class="col-2">
              <label for="floatingInput">Estado</label>
              <select name="EstadoDs" id="EstadoDs" [(ngModel)]="valorEstado" formControlName="EstadoDs" (ngModelChange)="atualizarEstado($event)">
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
                <option value="EX">Estrangeiro</option>
                </select>
            </div>
            <div class="col-4">
              <label for="floatingInput">Complemento</label>
              <input type="text" [(ngModel)]="registro.Complemento" formControlName="Complemento" name="inputComplemento">
            </div>
            <div class="row">
              <div class="col-4 checked-input">
                <label for="floatingInput">Tipo de Residência:</label>
                <div class="checked-col">
                  <label for="floatingInput">
                    <input type="radio" name="TipoResidencia" value="Casa Propia" formControlName="TipoResidencia"
                      [(ngModel)]="registro.TipoResidencia">
                    Casa Própria
                  </label>
                  <label for="floatingInput">
                    <input type="radio" name="TipoResidencia" value="Alugada" formControlName="TipoResidencia"
                      [(ngModel)]="registro.TipoResidencia">
                    Alugada
                  </label>
                </div>
              </div>
              <div class="col-4 checked-input">
                <label for="floatingInput">Tem CNPJ?</label>
                <div class="checked-col"
                  (ngModelChange)="cnpjConditionallyRequiredValidator($event)">
                  <label for="floatingInput">
                    <input type="radio" name="TemCNPJ" [value]="false" [(ngModel)]="meuInputAnterior"
                      (ngModelChange)="atualizarInputAnterior($event)" formControlName="TemCNPJ">
                    Não
                  </label>
                  <label for="floatingInput">
                    <input type="radio" name="TemCNPJ" [value]="true" [(ngModel)]="meuInputAnterior"
                      (ngModelChange)="atualizarInputAnterior($event)" formControlName="TemCNPJ">
                    Sim
                  </label>
                </div>
              </div>
              <div class="col-4 cnpj-input">
                <label for="meu-input-novo" *ngIf="meuInputAnterior == true">
                  CNPJ
                  <input type="text" name="cnpj"  [(ngModel)]="registro.CNPJ"
                    formControlName="CNPJ" input="inputCNPJ">
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dados-profissionais">
        <h5 class="title">Dados Profissionais</h5>
        <div class="form">
          <div class="row">
            <div class="col-4 col-md-4">
              <label for="floatingInput">Profissão</label>
              <div style="position: relative; max-width: 100%;">
                <app-typeahead name="ProfissaoAutoComplete" [lista]="data" [searchText]="registro.Profissao"
                (searchFunction)="onChangeProfissao($event)" (selectItem)="selecionaProfissao($event)">
                <input autocomplete="off" class="form-control input-sm" formControlName="profissao"
                  [(ngModel)]="registro.Profissao" name="profissao" />
                </app-typeahead>
              </div>
            </div>
            <div class="col-4">
              <label for="floatingInput">Empresa</label>
              <input type="text" [(ngModel)]="registro.ReferenciaComercial" formControlName="ReferenciaComercial"
                name="inputReferenciaComercial">
            </div>
            <div class="col-4">
              <label for="floatingInput">Renda</label>
              <input type="text" currencyMask [options]="{prefix: 'R$ ', thousands: '.', decimal: ','}"
                [(ngModel)]="registro.Renda" formControlName="Renda" name="InputRenda">
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <label for="floatingInput">Endereço Comercial</label>
              <input type="text" [(ngModel)]="registro.EnderecoComercial" formControlName="EnderecoComercial"
                name="inputEnderecoComercial">
            </div>
            <div class="col-4">
              <label for="floatingInput">Telefone Comercial</label>
              <input type="text" mask="99 999999999||99 99999999" [(ngModel)]="registro.TelefoneComercial"
                formControlName="TelefoneComercial" name="inputTelefoneComercial">
            </div>
            <div class="col-4">
              <label for="floatingInput">Ramal</label>
              <input type="text" mask="9990" [(ngModel)]="registro.Ramal" formControlName="Ramal" name="inputRamal">
            </div>
          </div>
        </div>
      </div>
      <div class="dados-bancarios">
        <h5 class="title">Dados Bancarios</h5>
        <div class="form">
          <div class="row">
            <div class="col-4 ">
              <label for="floatingInput">Número do Banco</label>
              <input type="text" mask="9990" [(ngModel)]="registro.BancoNumero" formControlName="BancoNumero"
                name="inputBancoNumero">
            </div>
            <div class="col-4">
              <label for="floatingInput">Cliente Desde (Mês/Ano)</label>
              <input type="text" [(ngModel)]="registro.ClienteDesde" maxlength="7" formControlName="ClienteDesde"
                name="inputClienteDesde" (keyup)="dateMask($event)">
            </div>
            <div class="col-4">
              <label for="floatingInput">Agência Número</label>
              <input autocomplete="off" type="text" [(ngModel)]="registro.AgenciaNumero" formControlName="AgenciaNumero"
                name="inputAgenciaNumero">
            </div>
            <div class="col-4">
              <label for="floatingInput">Agência Dígito</label>
              <input autocomplete="off" type="text" [(ngModel)]="registro.AgenciaDigito" formControlName="AgenciaDigito"
                name="inputAgenciaDigito">
            </div>
            <div class="col-4">
              <label for="floatingInput">Conta Número</label>
              <input autocomplete="off" type="text" [(ngModel)]="registro.ContaNumero" formControlName="ContaNumero"
                name="inputContaNumero">
            </div>
            <div class="col-4">
              <label for="floatingInput">Conta Dígito</label>
              <input autocomplete="off" type="text" [(ngModel)]="registro.ContaDigito" formControlName="ContaDigito"
                name="inputContaDigito">
            </div>
          </div>
        </div>
      </div>
      <div class="enviar-email" *ngIf="this.registro.FinanceiroTerceiros">
        <h5 class="title">Aviso de Financiamento de Terceiros</h5>
        <div class="row">
          <div class="col-8 bg-danger">
            <div innerHTML="{{avisoTerceiros}}">
            </div>
          </div>
          <div class="col-4">
            <button type="button" class="btn btn-primary" (click)="copyToClipboard()">Copiar Assunto do Email</button>
          </div>
        </div>
      </div>
      <div class="destino">
        <h5 class="title">Destino</h5>
        <div class="row">
          <div class="col-12 ">
            <label for="floatingInput">País de Destino</label>
            <select class="form-control" [(ngModel)]="registro.Produto" formControlName="Produto" name="inputProduto">
              <option *ngFor="let pais of paises" [value]="pais">{{pais}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="acoes">
        <h5 class="title">Ações</h5>
        <div *ngIf="mensagensErro?.length > 0">
          <ul>
            <li *ngFor="let mensagem of mensagensErro">{{mensagem}}<li>
          </ul>
        </div>
        <div *ngIf="mensagemSucesso?.length > 0" style="width: 100%">
          <div class="alert alert-success" style="width: 100%">{{mensagemSucesso}}</div>
        </div>

        <div class="row">
          <div class="col col-md-12">
            <div *ngIf="!form.valid && !form.pristine">Para salvar o registro é necessário atender todos os requisitos
              <ul>
                <li *ngFor="let erro of getFormValidationErrors(form)">
                  <span *ngIf="erro.keyError == 'required'">O campo {{ erro.key }} é obrigatório.</span>
                  <span *ngIf="erro.keyError == 'minlength'">O campo {{ display[erro.key] != null ? display[erro.key] : erro.key }} contém {{ erro.value.actualLength }} caracteres, porém precisa de {{ erro.value.requiredLength }} caracteres</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col col-md-3 mt-2" *ngIf="registro.Status == 0">
            <button class="btn btn-success btn-block" type="button" (click)="salvar()"
              [disabled]="registro.Status != 0 || !form.valid">Salvar</button>
          </div>
          <div class="col col-md-3 mt-2" *ngIf="registro.Status == 0 && salvo">
            <button class="btn btn-success btn-block" type="button" (click)="confirmarEnviarProposta()">Enviar Proposta</button>
          </div>
          <div class="col col-md-3 mt-2" *ngIf="registro.Status != 0">
            <button class="btn btn-success btn-block" type="button" (click)="verificarStatus()">Verificar Status</button>
          </div>
          <div class="col col-md-3 mt-2">
            <button class="btn btn-success btn-block" type="button" (click)="irReserva()">Acessar Orçamento</button>
          </div>
        </div>
      </div>
      <div *ngIf="visualiza_analise_financiamento" class="analise-financiamento">
        <h5 class="title">Análise</h5>
        <div>
          <div class="alert alert-danger" role="alert">
            <h2>
              <strong>Uso exclusivo de empresa credenciada para auxilio na aprovação de crédito. A divulgação de tais informações a terceiros sujeitará o infrator ás sanções penais.</strong>
            </h2>
          </div>
          <div *ngFor="let historico of registro.Historicos">
            <div class="row mb-3">
              <div class="col-sm-2" style="text-align: center">
                <span class="badge badge-primary" *ngIf="historico.Status == 0">Não enviado</span>
                <span class="badge badge-info" *ngIf="historico.Status == 1">Em Análise</span>
                <span class="badge badge-success" *ngIf="historico.Status == 2">Aprovado</span>
                <span class="badge badge-danger" *ngIf="historico.Status == 3">Reprovado</span>
                <span class="badge badge-warning" *ngIf="historico.Status == 4">Cancelado</span>
                <span class="badge badge-warning" *ngIf="historico.Status == 5">Erro</span>
                <span class="badge badge-info" *ngIf="historico.Status == 6">Pendente</span>
                <span class="badge badge-dark" *ngIf="historico.Status == 8">Histórico</span>
              </div>

              <div class="col-sm-2">
                {{ historico.CriadoEm | date: 'dd/MM/yyyy HH:mm' }}
              </div>

              <div class="col-sm-2">
                <strong>{{ historico.CriadoPor }}</strong>
              </div>

              <div class="col-sm-6">
                <strong>{{ historico?.Observacao }}</strong>
              </div>
            </div>
            <table class="table table-bordered">
              <tr *ngFor="let validacao of historico.Validacoes">
                <td width="20">
                  <i class="fa fa-check" style="color: #0abb87" *ngIf="validacao.Valido"></i>
                  <i class="fa fa-times" style="color: #fd397a" *ngIf="!validacao.Valido"></i>
                </td>
                <td>
                  {{ validacao.Log }}
                </td>
              </tr>
            </table>
          </div>
          <div class="kt-portlet__body pb-3 pt-3 col-sm-6">
            <h4>Consulta SPC</h4>
            <div class="col-sm-12">
              <fieldset class="border p-2">
                <h5>DADOS CADASTRAIS</h5>
                <div class="col-sm-12 div-card-12">
                  <div class="row">
                    <div class="col-sm-6 titulo-dado-analise">
                      <strong class="dado-cliente titulo">Nome:</strong> <p class="dado-cliente dado">{{ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.nome}}</p>
                    </div>
                    <div class="col-sm-6 titulo-dado-analise">
                      <strong class="dado-cliente titulo">CPF:</strong> <p class="dado-cliente dado">{{ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.cpf?.numero}}</p>
                    </div>
                    <div class="col-sm-6 titulo-dado-analise">
                      <strong class="dado-cliente titulo">Data de Nascimento:</strong> <p class="dado-cliente dado">{{ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.datanascimento | date: 'dd/MM/yyyy'}}</p>
                    </div>
                    <div class="col-sm-6 titulo-dado-analise">
                      <strong class="dado-cliente titulo">Nome da mãe:</strong> <p class="dado-cliente dado">{{ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.nomemae}}</p>
                    </div>
                    <div class="col-sm-6 titulo-dado-analise">
                      <strong class="dado-cliente titulo">Email:</strong> <p class="dado-cliente dado">{{ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.email}}</p>
                    </div>
                    <div class="col-sm-6 titulo-dado-analise">
                      <strong class="dado-cliente titulo">Data/Hora Consulta:</strong> <p class="dado-cliente dado">{{ConsultaSPC?.resultado?.data | date: 'dd/MM/yyyy HH:mm'}}</p>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset class="border p-2">
                <h5>Melhor Endereço/Telefone no SCPC</h5>
                <div class="col-sm-12 div-card-12">
                  <div class="row">
                    <div class="col-sm-6 titulo-dado-analise">
                        <strong class="dado-cliente titulo">Endereço</strong> <p class="dado-cliente dado">{{ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.endereco?.logradouro}}{{ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.endereco?.numero}}</p>
                    </div>
                    <div class="col-sm-6 titulo-dado-analise lado-direto">
                        <strong class="dado-cliente titulo">Complemento</strong> <p class="dado-cliente dado">{{ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.endereco?.complemento}}</p>
                    </div>
                    <div class="col-sm-6 titulo-dado-analise">
                        <strong class="dado-cliente titulo">Bairro</strong> <p class="dado-cliente dado">{{ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.endereco?.bairro}}</p>
                    </div>
                    <div class="col-sm-6 titulo-dado-analise lado-direto">
                        <strong class="dado-cliente titulo">Cidade</strong> <p class="dado-cliente dado">{{ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.endereco?.cidade?.nome}}</p>
                    </div>
                    <div class="col-sm-6 titulo-dado-analise">
                        <strong class="dado-cliente titulo">UF</strong> <p class="dado-cliente dado">{{ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.endereco?.cidade?.estado?.siglauf}}</p>
                    </div>
                    <div class="col-sm-6 titulo-dado-analise lado-direto">
                        <strong class="dado-cliente titulo">CEP</strong>  <p class="dado-cliente dado">{{ConsultaSPC.resultado?.consumidor?.consumidorpessoafisica?.endereco?.cep}}</p>
                    </div>
                    <div class="col-sm-6 titulo-dado-analise">
                        <strong class="dado-cliente titulo">Telefone</strong> <p class="dado-cliente dado">({{ ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.telefoneresidencial?.numeroddd}}) {{ ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.telefoneresidencial?.numero}}</p>
                    </div>
                    <div class="col-sm-6 titulo-dado-analise lado-direto">
                        <strong class="dado-cliente titulo">Telefone</strong> <p class="dado-cliente dado">({{ ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.telefonecelular?.numeroddd}}) {{ ConsultaSPC?.resultado?.consumidor?.consumidorpessoafisica?.telefonecelular?.numero}}</p>
                    </div>
                  </div>
                </div>
              </fieldset>

              <fieldset class="border p-2">
                <h5>PARTICIPAÇÃO EM EMPRESAS</h5>
                <div class="col-sm-12 div-card-12">
                    <div class="row">
                        <div class="col-sm-12" *ngFor="let consulta of ConsultaSPC?.resultado?.participacaoempresa?.Items">
                            <div class="row" *ngFor="let valor of consulta.valores">
                                <div class="col-sm-8 titulo-dado-analise">
                                    <strong>Razão Social / CNPJ</strong> <p class="dado-cliente dado"> {{valor.nome}} / {{valor.documento}}</p>
                                </div>
                                <div class="col-sm-4 pl-3 titulo-dado-analise">
                                    <strong>Relacionamento / Participação</strong> <p class="dado-cliente dado"> {{valor.tiporelacionamento}} / {{valor.porcentualparticipacao}} %</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </fieldset>

            <fieldset class="border p-2">
              <h5>PROTESTOS</h5>
              <div class="col-sm-12 div-card-12">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="row" *ngFor="let valor of ConsultaSPC?.resultado?.protesto?.Items">
                      <div class="col-sm-9 titulo-dado-analise">
                        <strong>Cidade</strong> <p class="dado-cliente dado"> {{valor.cartorio?.cidade?.nome}} / {{valor.cartorio?.cidade?.estado?.siglauf}}</p>
                      </div>
                      <div class="col-sm-3 pl-3 titulo-dado-analise">
                        <strong>Valor</strong> <p class="dado-cliente dado"> {{valor.valor | currency:'BRL':'':'2.2-2'}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12" *ngFor="let valor of ConsultaSPC?.resultado?.protesto?.Items">
                    <div class="row" v-for="valor in consulta">
                      <div class="col-sm-6 titulo-dado-analise">
                        <strong>Cidade / Associado ou credor</strong> <p class="dado-cliente dado"> {{valor?.cidadeassociado?.nome}} - {{valor?.cidadeassociado?.estado?.siglauf}} / {{valor.nomeassociado}}</p>
                      </div>
                      <div class="col-sm-6 pl-3 titulo-dado-analise">
                        <strong>Comprador, fiador ou avalista / Valor</strong> <p class="dado-cliente dado">{{valor.compradorfiadoravalista}} / {{valor.valor | currency:'BRL':'':'2.2-2'}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset class="border p-2">
              <h5>REGISTRO DE SPC</h5>
              <div class="col-sm-12 div-card-12">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="row" *ngFor="let valor of ConsultaSPC?.resultado?.spc?.Items">
                      <div class="col-sm-6 titulo-dado-analise">
                        <strong>Cidade / Associado ou credor</strong> <p class="dado-cliente dado"> {{valor?.cidadeassociado?.nome}} - {{valor.cidadeassociado?.estado?.siglauf}} / {{valor.nomeassociado}}</p>
                      </div>
                      <div class="col-sm-6 pl-3 titulo-dado-analise">
                        <strong>Comprador, fiador ou avalista / Valor</strong> <p class="dado-cliente dado">{{valor.compradorfiadoravalista}} / {{valor.valor | currency:'BRL':'':'2.2-2'}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12" *ngFor="let consulta of ConsultaSPC?.resultado?.spc?.Items">
                    <div class="row" *ngFor="let valor of consulta">
                      <div class="col-sm-6 titulo-dado-analise">
                        <strong>Cidade / Associado ou credor</strong> <p class="dado-cliente dado"> {{valor.cidadeassociado.nome}} - {{valor.cidadeassociado.estado.siglauf}} / {{valor.nomeassociado}}</p>
                      </div>
                      <div class="col-sm-6 pl-3 titulo-dado-analise">
                        <strong>Comprador, fiador ou avalista / Valor</strong> <p class="dado-cliente dado">{{valor.compradorfiadoravalista}} / {{valor.valor | currency:'BRL':'':'2.2-2'}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border p-2">
              <h5>CHEQUES SEM FUNDO - CCF</h5>
              <div class="col-sm-12 div-card-12" *ngIf="ConsultaSPC?.resultado?.ccf?.Items">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="row" *ngFor="let valor of ConsultaSPC?.resultado?.ccf?.Items">
                      <div class="col-sm-6 titulo-dado-analise">
                        <strong>Último cheque - Banco - Agência </strong> <p class="dado-cliente dado"> {{valor.dataultimocheque  | date :'dd/MM/yyyy'}} - {{valor.ultimocheque.dadosbancarios.banco.nome}} - {{valor.ultimocheque.dadosbancarios.numeroagencia}}</p>
                      </div>
                      <div class="col-sm-6 pl-3 titulo-dado-analise">
                        <strong>Motivo / Origem</strong> <p class="dado-cliente dado">{{valor.motivo.descricao}} / {{valor.origem}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border p-2">
              <h5>PENDÊNCIAS FINANCEIRAS</h5>
              <div class="col-sm-12 div-card-12" *ngIf="ConsultaSPC?.resultado?.pendenciafinanceira?.Items">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="row" *ngFor="let valor of ConsultaSPC?.resultado?.pendenciafinanceira?.Items">
                      <div class="col-sm-9 titulo-dado-analise">
                        <strong>Origen - Modalidade - Cidade</strong> <p class="dado-cliente dado"> {{valor?.origem}} - {{valor.tituloocorrencia}} - {{valor?.cidade?.nome}} / {{valor?.cidade?.estado?.siglauf}}</p>
                      </div>
                      <div class="col-sm-3 pl-3 titulo-dado-analise">
                        <strong>Valor</strong> <p class="dado-cliente dado"> {{valor.valorpendencia | currency:'BRL':'':'2.2-2'}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset class="border p-2">
              <h5>CONSULTAS ANTERIORES</h5>
              <div class="col-sm-12 div-card-12" *ngIf="ConsultaSPC?.resultado?.consultarealizada?.Items">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="row" *ngFor="let valor of ConsultaSPC?.resultado?.consultarealizada?.Items">
                        <div class="col-sm-8 titulo-dado-analise" *ngIf="valor?.origemassociado?.nome!=null">
                          <strong>Razão Social / Cidade</strong> <p class="dado-cliente dado"> {{valor?.nomeassociado}} / {{valor?.origemassociado.nome}} - {{valor?.origemassociado?.estado?.siglauf}}</p>
                        </div>
                        <div class="col-sm-4 titulo-dado-analise">
                          <strong>Data</strong> <p class="dado-cliente dado"> {{valor.dataconsulta  | date :'dd/MM/yyyy HH:mm'}}</p>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
</div>

<ng-template  #contentBoleto let-modal id="contentBoleto">
  <app-financiamento-boletos [FinanciamentoId]="registro.Id"></app-financiamento-boletos>
</ng-template>

